import { useState } from "react";
import { LockOutlined, UserOutlined } from "@ant-design/icons";
import { Form, Input, Button, Checkbox, Card, message } from "antd";
import { useHistory } from "react-router-dom";

import { loginUser } from "actions";
import { AUTHORIZATION_KEY } from "global_constants";

import AccountHook from "hooks/account";

const Login = ({ setAccountData }) => {
  const [form] = Form.useForm();
  const history = useHistory();
  const [processing, setProcessing] = useState(false);

  function onSubmit(values) {
    setProcessing(true);
    loginUser(values)
      .then((response) => {
        setProcessing(false);

        if (response.otp_enabled) {
          history.push({
            pathname: '/validate-2fa',
            state: {
              user_id: response.user_id,
            }
          });
        } else {
          setAccountData(response);
          localStorage.setItem(AUTHORIZATION_KEY, response.token);
          // navigate to auction-management
          history.push('/auction-management');
        }
      })
      .catch((err) => {
        setProcessing(false);
        message.error(err.response?.data?.error);
      });
  }

  return (
    <div className="login-page">
      <Card bordered>
        <div className="image-card"></div>
        <p className="text-2xl semi-bold mb-16">S. H. Silver Jewelry Portal</p>
        <Form form={form} onFinish={(values) => onSubmit(values)}>
          <Form.Item
            name="email"
            rules={[
              {
                type: "email",
                message: "The input is not valid E-mail!",
              },
              {
                required: true,
                message: "Please input your email!",
              },
            ]}
          >
            <Input
              size="middle"
              prefix={<UserOutlined />}
              placeholder="Email"
            />
          </Form.Item>
          <Form.Item
            name="password"
            rules={[
              {
                required: true,
                message: "Please input your Password!",
              },
              {
                min: 5,
                message: "The Password must be at least 5 characters long",
              },
            ]}
          >
            <Input.Password
              size="middle"
              prefix={<LockOutlined />}
              placeholder="Password"
            />
          </Form.Item>
          <Form.Item name="remember" valuePropName="checked">
            <Checkbox>Remember me</Checkbox>
          </Form.Item>
          <Form.Item noStyle>
            <Button
              block
              type="primary"
              className="mt-8"
              htmlType="submit"
              loading={processing}
            >
              Log in
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};
export default AccountHook(Login);
